module.exports = __webpack_public_path__ + "img/ppt.147645d8.svg";